<script>

import {defineComponent} from "vue";
import InfoCard from "@/components/InfoCard.vue";

export default defineComponent({
  components: {InfoCard},
  computed: {
    translatedCards() {
      return this.$t('book.cards');
    }
  }
})
</script>

<template>
  <div id="book">
    <div class="container-fluid start-panel mb-5">
      <div class="row">

        <div class="col-lg-6 px-5 align-self-center book-section">
          <div class="main-heading">
            <h2 class="text-primary">{{$t("book.subHeadingMinecraft")}}</h2>
            <h1>{{$t("book.headingMinecraft")}}</h1>
          </div>

          <p class="my-5">{{$t("book.textMinecraft")}}</p>

          <button type="button" class="btn btn-lg btn-primary mx-1"
                  onclick="window.open('https://www.rheinwerk-verlag.de/6140/?GPP=schloool', '_blank')">
            {{$t("book.buttonRheinwerk")}}
          </button>

          <div class="button-group my-3">
            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.amazon.de/dp/3367109444', '_blank')">
              {{$t("book.buttonAmazon")}}
            </button>

            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.thalia.de/shop/home/artikeldetails/A1075798618', '_blank')">
              {{$t("book.buttonThalia")}}
            </button>

            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.hugendubel.de/de/buch_kartoniert/max_schlosser-let_s_craft_code_-50951359-produkt-details.html', '_blank')">
              {{$t("book.buttonHugendubel")}}
            </button>
          </div>
        </div>

        <div class="col-lg-6 d-flex justify-content-center py-3">
          <img src="./assets/book-minecraft-3d.webp" class="mx-auto book-img" loading="lazy" alt="Minecraft Book">
        </div>

      </div>
    </div>

    <hr class="book-separator d-lg-none">

    <div class="container-fluid start-panel">
      <div class="row">
        <div class="col-lg-6 d-flex justify-content-center py-3">
          <img src="./assets/book-3d.webp" class="mx-auto book-img" loading="lazy" alt="Book">
        </div>

        <div class="col-lg-6 px-5 align-self-center book-section">
          <div class="main-heading">
            <h2 class="text-primary">{{$t('book.subHeading')}}</h2>
            <h1>{{$t('book.heading')}}</h1>
          </div>

          <p class="my-5">{{$t('book.mainText')}}</p>

          <button type="button" class="btn btn-lg btn-primary mx-1"
                  onclick="window.open('https://www.rheinwerk-verlag.de/spieleentwicklung-mit-unity_6400/', '_blank')">{{$t('book.buttonRheinwerk')}}</button>

          <div class="button-group my-3">
            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.amazon.de/dp/3836295393', '_blank')">{{$t('book.buttonAmazon')}}</button>

            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.thalia.de/shop/home/artikeldetails/A1070283958', '_blank')">{{$t('book.buttonThalia')}}</button>

            <button type="button" class="btn btn-lg btn-secondary mx-1 my-1"
                    onclick="window.open('https://www.hugendubel.de/de/buch_gebunden/max_schlosser-spieleentwicklung_mit_unity-47207821-produkt-details.html',
                     '_blank')">{{$t('book.buttonHugendubel')}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid mt-5 explanation">
      <h1 class="text-center my-5">{{$t('book.mainAspects')}}</h1>

      <div class="row justify-content-center mb-5">
        <InfoCard :title="$t('book.cards.theory.title')" :text="$t('book.cards.theory.text')" icon="fa-brain"/>
        <InfoCard :title="$t('book.cards.practice.title')" :text="$t('book.cards.practice.text')" icon="fa-pencil"/>
        <InfoCard :title="$t('book.cards.community.title')" :text="$t('book.cards.community.text')" icon="fa-users"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-size: 35pt;
}

.book-section p {
  font-size: 15pt;
}

.book-img {
  height: 60vh;
}

.book-separator {
  width: 80%;
  margin: 0 auto 3rem;
  border-top: 2px solid var(--bs-primary);
  opacity: 0.5;
}

@media only screen and (max-width: 991px) {
  .book-img {
    height: auto;
    width: min(70vw, 400px);
  }
}
</style>